<div (click)="click()" fxLayout="column" fxLayoutAlign="center center" class="size" [ngClass]="{'selected': selected, 'disabled': disabled}">
    <span>{{size}}</span>
</div>
